import
  React
from 'react';

import
  styled
from 'styled-components';

import {
  Colors,
  DeviceMediaQueries,
  Images,
  Image,
  Logger,
  Messages,
  isValidEmail,
  isValidProviderResult,
} from 'common';

import {
  Button,
  PSmaller,
  TextInput,
} from 'common/components';

import {
  withCommon,
} from 'common/hocs';

import {
  EmailImage,
  HeaderText,
  SubHeaderText,
} from './forgotPasswordStyled';

import {
  Container,
  InputContainer,
} from '../identityStyled';

import {
  IdentityProvider,
} from 'providers';

const BackContainer = styled.div`
  background-color: ${Colors.White};
  position: absolute;
  top: 20px;
  left: 20px;
  height: 35px;
  border-radius: 50%;
  display: flex;
  align-items: center;

  @media ${DeviceMediaQueries.Tablet} {
    display: none;
  }
`;

class ForgotPasswordEmailUI extends React.Component {

  state = {
    showButtonLoading: false,
    hasEmailError: false,
    showError: false,
    isEmailSent: false,
    emailMessage: '',
    errorMessage: '',
  };

  email = '';

  onEmailChange = val => {
    
    this.email = val;

    if (this.state.hasEmailError || this.state.showError) {

      this.setState({
        hasEmailError: false,
        showError: false,
      });
    }
  };

  onResetPasswordClick = () => {

    if (!isValidEmail(this.email)) {

      this.setState({
        hasEmailError: true,
        emailMessage: 'Please provide a valid email',
      });

      return;
    }

    this.setState({
      showButtonLoading: true,
    });

    IdentityProvider
      .requestPasswordChange(
        this.email,
      )
      .then(ret => {

        if (!isValidProviderResult(ret)) {

          Logger.error(ret.message || Messages.TechnicalError);

          this.setState({
            showError: true,
            errorMessage: ret.message || Messages.TechnicalError,
            showButtonLoading: false,
          });

          return;
        }

        this.setState({
          isEmailSent: true,
        });
      })
      .catch(e => {

        Logger.error(e);

        this.setState({
          showError: true,
          errorMessage: Messages.TechnicalError,
          showButtonLoading: false,
        });
      });
  };

  onBackClick = () => {
    this.props.common.navigate('/identity/login');
  };

  render () {

    if (this.state.isEmailSent) {

      return (

        <Container>
        
          <EmailImage
            src={Images.Icons.EmailSent}
          />

          <HeaderText>
            Check your mail
          </HeaderText>

          <SubHeaderText>
            If your account exists you will receive an email with your password recovery instructions
          </SubHeaderText>

          <Button
            text={'BACK TO LOGIN'}
            onClick={this.onBackClick}
          />

        </Container>
      );
    }

    return (

      <Container>

        <HeaderText>
          Forgot your password?
        </HeaderText>

        <SubHeaderText>
          Please confirm your email and we'll send an email with the instructions to reset your password
        </SubHeaderText>

        { this.state.showError &&
          
          <PSmaller
            color={Colors.Red}
            padding={'0 0 10px 0'}
            textAlign={'center'}>

              {this.state.errorMessage}
          </PSmaller>
        }

        <InputContainer>

          <TextInput
            type={'email'}
            placeholder={'Email'}
            width={'100%'}
            onChange={this.onEmailChange}
            hasError={this.state.hasEmailError}
            errorMessage={this.state.emailMessage}
          />

          <Button
            text={'SEND INSTRUCTIONS'}
            width={'100%'}
            showLoading={this.state.showButtonLoading}
            onClick={this.onResetPasswordClick}
          />

        </InputContainer>

        
        <BackContainer>

          <Image
            src={Images.Icons.Back}
            width={'35px'}
            height={'35px'}
            onClick={this.onBackClick}
          />

        </BackContainer>

      </Container>
    );
  }
}

export const ForgotPasswordEmail = withCommon(
  ForgotPasswordEmailUI, {
    showHeader: false,
    showSideMenu: false,
    requiresAuth: false,
    addExitSafeguard: false,
  }
);